/**
 * Utility functions extracted from CaseDetails.tsx
 */

import slugify from "slugify";

/**
 * Type guard to check if an object is a case entity
 */
export function isCaseEntity(
  obj: unknown
): obj is { id: number; documentId: string } {
  return (
    !!obj &&
    typeof obj === "object" &&
    "id" in obj &&
    "documentId" in obj
  );
}

/**
 * Find case by slugified name with localization fallback
 */
export function findCaseBySlug(
  casesList: Array<{
    name?: string;
    localizations?: Array<{
      name?: string;
    }>;
  }> | null | undefined,
  targetSlug: string
): unknown | null {
  if (!casesList || !Array.isArray(casesList)) {
    return null;
  }

  let caseData = casesList.find(
    (item) =>
      item.name &&
      slugify(item.name.toLowerCase()) === targetSlug
  );

  if (!caseData) {
    caseData = casesList.find((item) => {
      if (!item.localizations) {
        return false;
      }

      return item.localizations.some(
        (localization) =>
          localization.name &&
          slugify(localization.name.toLowerCase()) === targetSlug
      );
    });
  }

  return caseData ?? null;
}

/**
 * Filter videos matching case name case-insensitively
 */
export function filterVideosByShowcase(
  videos: Array<{
    contentType?: {
      showcase?: {
        name?: string;
      };
    };
  }> | null | undefined,
  caseName: string
): unknown[] {
  if (!videos || !caseName) {
    return [];
  }

  return videos.filter((video) => {
    const showcaseName =
      video?.contentType?.showcase?.name;
    return showcaseName?.toLowerCase() === caseName.toLowerCase();
  });
}
